import cn from 'classnames'
import { useMemo } from 'react'

import { ContactFlagRequestAction } from 'clickNgo/configs/profiling/contactFlag'
import { IContactFlag } from 'clickNgo/entities/contactFlag'
import { RenderWhen } from 'cng-common/components/renderWhen'
import { Checkbox } from 'core-components/library/checkbox'
import { getFormatDate } from 'core/classes/helpers/DateHelper'
import { List } from 'shared/components/list'

import styles from './ContactFlag.module.scss'

interface Props {
  flag: IContactFlag
  caption?: string
  isDisabled?: boolean
  isReadOnly?: boolean
  isSelected: boolean
  onSelect: (isSelected: boolean) => void
}

export const ContactFlag = ({
  flag,
  caption,
  isSelected,
  onSelect,
  isDisabled,
  isReadOnly,
}: Props) => {
  const displayCaption = caption || flag.caption || flag.code
  const status = flag.status || '-'
  const action = flag.action || '-'
  const createdBy = flag.createdBy || '-'
  const created = flag.created ? getFormatDate(flag.modified, 'date2') : '-'

  const badgeActionColorStyle = useMemo(() => {
    switch (flag.action) {
      case ContactFlagRequestAction.Add:
        return styles.badgeAdd
      case ContactFlagRequestAction.Delete:
        return styles.badgeRemove
      default:
        return ''
    }
  }, [flag.action])

  return (
    <List.Label
      className={cn(styles.item, { [styles.disabled]: isDisabled })}
      isDisabled={isDisabled}
    >
      <RenderWhen condition={!isReadOnly}>
        <Checkbox
          className={styles.checkbox}
          checked={isSelected}
          onChange={onSelect}
          size="sm"
          disabled={isDisabled}
        />
      </RenderWhen>
      <div className={styles.caption}>
        {displayCaption}
        <RenderWhen condition={Boolean(flag.status)}>
          <div className={styles.createdInfo}>
            <span className={styles.requestor}>{createdBy}</span>
            <span className={styles.date}>{created}</span>
          </div>
        </RenderWhen>
      </div>
      <RenderWhen condition={Boolean(flag.status)}>
        <div className={styles.badge}>
          <span className={styles.badgeStatus}>{status}</span>
          <span className={cn(styles.badgeAction, badgeActionColorStyle)}>{action}</span>
        </div>
      </RenderWhen>
    </List.Label>
  )
}
